<template>
  <div>
    <router-view v-if="isDefaultPreview"></router-view>
    <DefaultPreview v-else :current-route="currentRoute" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import { unsetMode } from '@utils/settings/tenant-user.util'
import layoutConstants from '@src/constants/layout-constant.js'
import { rourterList } from '@router/layouts/main-layout/main-layout-routes.js'
import DefaultPreview from '@src/router/layouts/feed/DefaultPreview.vue'
import { objectDeepCopy } from '@/src/utils/generalUtil'
import { checkScopeLevelByBasedOn } from '@src/utils/layoutUtils.js'
export default {
  name: 'MainLayout',
  components: { DefaultPreview },

  beforeRouteUpdate(to, from, next) {
    this.modifyLeftBarDropdown(to.name)
    next()
  },

  data() {
    return {
      TENANT_ROLES,
      unsetModeExcludedList: [TENANT_ROLES.GUARDIAN],
      currentRoute: {},
      isDefaultPreview: false,
    }
  },

  computed: {
    ...mapState('featureNaming', ['routerList']),
    ...mapGetters('layout', ['userRole', 'isMultipleCampusesAllowed']),
    ...mapState({
      isAssociatedStudentProfileActive: (state) => state.layout.isAssociatedStudentProfileActive,
      currentCampusScope: (state) => state.layout.currentCampusScope,
      currentClassScope: (state) => state.layout.currentClassScope,
      currentSectionScope: (state) => state.layout.currentSectionScope,
      leftBarContent: (state) => state.layout.leftBarContent,
    }),
    routeContext() {
      return {
        route: this.$route,
        campus: this.currentCampusScope,
        class: this.currentClassScope,
        section: this.currentSectionScope,
        routes: this.leftBarContent?.routes,
      }
    },
  },

  watch: {
    routeContext: {
      deep: true,
      immediate: true,
      handler(ctx) {
        if (!ctx.routes?.length) return
        this.currentRoute = this.findRouteByName(ctx.route.name, ctx.routes)
        this.isDefaultPreview = this.checkScopeLevelByBasedOn(this.currentRoute?.basedOn, {
          currentCampusScope: this.currentCampusScope,
          currentClassScope: this.currentClassScope,
          currentSectionScope: this.currentSectionScope,
        })
      },
    },
  },

  created() {
    if (!this.unsetModeExcludedList.includes(this.userRole)) {
      unsetMode(['student', 'teacher'])
    }
    const isUpper = !this.currentCampusScope
    this.fetchFeatureRename(isUpper).then(() => {
      this.setLeftBar()
    })
  },

  methods: {
    rourterList,
    checkScopeLevelByBasedOn,
    setLeftBar() {
      const guardianActiveProfile =
        this.userRole === TENANT_ROLES.GUARDIAN && !this.isAssociatedStudentProfileActive

      const filteredRoutes =
        this.userRole === TENANT_ROLES.GUARDIAN
          ? this.rourterList(this.routerList, this.isMultipleCampusesAllowed).filter((route) =>
              guardianActiveProfile ? route.isGuardianActive : !route.isGuardianActive,
            )
          : this.rourterList(this.routerList, this.isMultipleCampusesAllowed)

      this.setLeftbarContent({
        customeHeader: 'left-bar-class-list',
        title: this.$route.params.className,
        SHOW_SECTION_DROPDOWN_TO: layoutConstants.showSectionDropdownTo,
        SHOW_CLASS_DROPDOWN_TO: layoutConstants.showClassDropdownTo,
        routes: filteredRoutes,
      })
    },

    getRouteName(item) {
      if (!item?.route) return null
      if (typeof item.route.name === 'string') return item.route.name
      if (item.route.name && typeof item.route.name === 'object') return item.route.name.name
      return null
    },

    findRouteByName(routeName, routes = [], inheritedBasedOn = undefined) {
      const routesList = objectDeepCopy(routes)
      if (!Array.isArray(routesList)) return null

      for (const originalItem of routesList) {
        const item = originalItem // cloned item
        const candidateName = this.getRouteName(item)
        if (candidateName === routeName) {
          if (!item.basedOn && inheritedBasedOn) item.basedOn = inheritedBasedOn
          return item
        }

        const nextInherited = item.basedOn || inheritedBasedOn

        if (Array.isArray(item.childs) && item.childs.length) {
          const found = this.findRouteByName(routeName, item.childs, nextInherited)
          if (found) return found
        }
        if (Array.isArray(item.children) && item.children.length) {
          const found = this.findRouteByName(routeName, item.children, nextInherited)
          if (found) return found
        }

        if (Array.isArray(item.routesName)) {
          if (
            item.routesName.includes(routeName) ||
            item.routesName.some((r) => r?.name === routeName)
          ) {
            if (!item.basedOn && inheritedBasedOn) item.basedOn = inheritedBasedOn
            return item
          }
        }
      }
      return null
    },

    ...mapActions('layout', ['setLeftbarContent', 'modifyLeftBarDropdown']),
    ...mapActions('featureNaming', ['fetchFeatureRename']),
  },
}
</script>
